import * as React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import './LinearLoader.scss';
// eslint-disable-next-line react/prop-types
const LinearLoader = ({ absolute = false, style = {} }) => (React.createElement(LinearProgress, { className: `linear-loader ${absolute ? 'absolute' : ''}`, color: "secondary", style: style }));
export default LinearLoader;
